import React, { useState, useEffect, useRef } from "react";
import Img from '../components/image';
import translate from '../locales/segments';

function Segments() {

    const segments = [

        {
            video: translate.content1.video,
            name: translate.content1.name,
            pronouns: translate.content1.pronouns,
            content: translate.content1.content,
            role: translate.content1.role,
            img: translate.content1.img,
            tag: translate.content1.tag
        },
        {
            video: translate.content2.video,
            name: translate.content2.name,
            pronouns: translate.content2.pronouns,
            content: translate.content2.content,
            role: translate.content2.role,
            img: translate.content2.img,
            tag: translate.content2.tag
        },
        {
            video: translate.content3.video,
            name: translate.content3.name,
            pronouns: translate.content3.pronouns,
            content: translate.content3.content,
            role: translate.content3.role,
            img: translate.content3.img,
            tag: translate.content3.tag
        },
        {
            video: translate.content4.video,
            name: translate.content4.name,
            pronouns: translate.content4.pronouns,
            content: translate.content4.content,
            role: translate.content4.role,
            img: translate.content4.img,
            tag: translate.content4.tag
        },
        {
            video: translate.content5.video,
            name: translate.content5.name,
            pronouns: translate.content5.pronouns,
            content: translate.content5.content,
            role: translate.content5.role,
            img: translate.content5.img,
            tag: translate.content5.tag
        },
        {
            video: translate.content6.video,
            name: translate.content6.name,
            pronouns: translate.content6.pronouns,
            content: translate.content6.content,
            role: translate.content6.role,
            img: translate.content6.img,
            tag: translate.content6.tag
        },

        {
            video: translate.content8.video,
            name: translate.content8.name,
            pronouns: translate.content8.pronouns,
            content: translate.content8.content,
            role: translate.content8.role,
            img: translate.content8.img,
            tag: translate.content8.tag
        },
        {
            video: translate.content9.video,
            name: translate.content9.name,
            pronouns: translate.content9.pronouns,
            content: translate.content9.content,
            role: translate.content9.role,
            img: translate.content9.img,
            tag: translate.content9.tag
        },
        {
            video: translate.content10.video,
            name: translate.content10.name,
            pronouns: translate.content10.pronouns,
            content: translate.content10.content,
            role: translate.content10.role,
            img: translate.content10.img,
            tag: translate.content10.tag
        },
    ];


    const [isOpen, setIsOpen] = useState(false);
    const [contentReady, setContentReady] = useState(false);
    const [segment, setSegment] = useState("");
    const [name, setName] = useState("");
    const [content, setContent] = useState("");
    const [role, setRole] = useState("");
    const [pronouns, setPronouns] = useState("");




    const node = useRef();

    const openMessage = () => {
        setIsOpen(true);
        setContentReady(true);
        document.getElementsByClassName('outerMessage')[0].classList.add('backdrop');

        document.getElementsByTagName('body')[0].style.overflow = 'hidden'


    }
    const closeMessage = () => {
        setIsOpen(false);
        setContentReady(false);
        document.getElementsByClassName('outerMessage')[0].classList.remove('backdrop');

        document.getElementsByTagName('body')[0].style.overflow = 'scroll'

    }



    const handleBlur = e => {
        if (node.current.contains(e.target)) {
            // inside click
            document.getElementsByClassName('outerMessage')[0].classList.add('backdrop');

            return;
        }
        // outside click 
        else {
            closeMessage();
        }
    };


    useEffect(() => {
        // add when mounted
        document.addEventListener("mousedown", handleBlur);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener("mousedown", handleBlur);
        };
    });




    return (
        <div className="segments angle">
            <div className="large container medium-padding-vertical white">
                <h2>{translate.name}</h2>
                <p>{translate.content}</p>
                <div className="segment-container">
                    {segments.map((segment, index) => (

                        <div key={index}>
                            {segment.video ?
                                <div className="segment-item" onClick={() => { openMessage(); setSegment(segment.video); setName(segment.name); setContent(segment.content); setRole(segment.role); setPronouns(segment.pronouns) }}>
                                    <div className="segment-img-container">
                                        <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={segment.img} alt={segment.name} />
                                    </div>
                                    <span>{segment.tag}</span>
                                </div>
                                : ''}
                        </div>

                    ))}




                </div>
                <div className="outerMessage">
                    <div ref={node} className={isOpen ? "message open" : "message"}>
                        {contentReady ? <><button aria-label={translate.close} onClick={closeMessage} className="eMedium medium uppercase bt-noir">{isOpen ? 'X' : ''}</button><div className="innerMessage" onBlur={handleBlur}>

                            <div className="moreInfoContainer" id="moreInfoContainer">
                                <div className="video">
                                    <h4 className="purple medium">{name} {pronouns ? <span className="black small">{pronouns}</span> : ''}</h4>
                                    <h5 className="black">{role}</h5>
                                    <p className="black medium">{content}</p>
                                    <div className="videoWrapper">
                                        <iframe src={segment} frameBorder="0" title={name}></iframe>
                                    </div>
                                </div>
                            </div>

                        </div></> : ''}
                    </div></div>

            </div>
        </div>
    )
}

export default Segments;